module.exports = __webpack_public_path__ + "a5179d90a15cd96a7411d1b12ef04d16.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GR.svg
// module id = vXKk
// module chunks = 0